import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import {toast, Toaster} from 'sonner'

const TrackApplication = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const [applicationId, setApplicationId] = useState('');
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [otp, setOtp] = useState(['', '', '', '', '', '']); // 6-digit OTP
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
    const [otpError, setOtpError] = useState(null);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [applicationStatus, setApplicationStatus] = useState(null);

    const handleTrackApplication = async () => {
        if(!applicationId){
            toast.error("Please Enter Application ID")
            return
        }
        setLoading(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/track`, {
                applicationId: applicationId,
            });
            setEmail(response.data.email);
            setIsOtpModalOpen(true);
            setLoading(false);
        } catch (error) {
            console.error('Error tracking application:', error);
            setLoading(false);
            if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Application ID not found or error occurred.');
            }
        }
    };

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus to the next input box
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    const handleOtpSubmit = async () => {
        setOtpError(null);

        if (otp.some(digit => digit === '')) {
            setOtpError('Please enter the complete OTP.');
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/verify-otp`, {
                email: email,
                otp: otp,
                applicationId: applicationId,
            });

            if (response.data.success) {
                setApplicationStatus(response.data.status);
                setIsOtpModalOpen(false);
                setIsStatusModalOpen(true);
            }
        } catch (error) {
            console.error('OTP verification error:', error);
            if (error.response && error.response.data && error.response.data.message) {
                setOtpError(error.response.data.message);
            } else {
                setOtpError('OTP verification failed. Please try again.');
            }
        }
    };

    return (
        <div className="bigscreen min-h-screen p-16">

            <div className='bg-white shadow-md rounded-[32px] py-16 p-10 flex flex-col gap-20'>
                <div className='flex gap-10 justify-between items-center'>

                    <div>
                        <div className="text-3xl font-bold mb-4">Track Your Application</div>
                        <div className='text-sm mx-auto font-light max-w-[360px]'>See the real-time status of your job application here using your application ID!</div>
                    </div>

                    <div className="mb-4 relative max-w-[600px] w-full">
                        <input
                            type="text"
                            placeholder="Enter Application ID"
                            value={applicationId}
                            onChange={(e) => setApplicationId(e.target.value)}
                            className="input !bg-grey-200 w-full pr-[110px]"
                        />
                        <button
                            onClick={handleTrackApplication}
                            className="button absolute !rounded-[8px] right-1 top-1 bottom-1 flex items-center"
                            disabled={loading}
                        >
                            {loading ? <ClipLoader color="white" size={15} /> : 'Submit'}
                        </button>
                    </div>

                </div>


                {isStatusModalOpen && (
                    // <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div className="flex flex-col gap-10 pb-16">

                        <div className="p-4 text-lg font-semibold bg-gray-50 border-l-4 border-blue-500 rounded-lg shadow-sm">
                            Application Status
                        </div>

                        {applicationStatus && (
                            <div className="mt-4 max-w-[660px] mx-auto w-full">
                                <div className="flex items-center justify-between relative">
                                    {/* Status Modal Content - Same as before */}
                                    <div className="relative z-10 mr-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus[0].Screening ||
                                                applicationStatus[1].Shortlisted ||
                                                applicationStatus[2].FinalInterview
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            1
                                        </div>
                                        <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Screening
                                        </span>
                                    </div>

                                    <div
                                        className={`h-1 bg-gray-300 absolute top-5 left-6 w-[calc(50%-40px)] ${applicationStatus[1].Shortlisted ||
                                            applicationStatus[2].FinalInterview
                                            ? '!bg-blue-500'
                                            : ''
                                            }`}
                                    />

                                    <div className="relative z-10 mx-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus[1].Shortlisted ||
                                                applicationStatus[2].FinalInterview
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            2
                                        </div>
                                        <span className="absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Shortlisted
                                        </span>
                                    </div>

                                    <div
                                        className={`h-1 bg-gray-300 absolute top-5 right-6 w-[calc(50%-40px)] ${applicationStatus[2].FinalInterview ? '!bg-blue-500' : ''
                                            }`}
                                    />

                                    <div className="relative z-10 ml-4">
                                        <div
                                            className={`w-10 h-10 rounded-full flex items-center justify-center ${applicationStatus[2].FinalInterview
                                                ? 'bg-blue-500 text-white'
                                                : 'bg-gray-300 text-gray-600'
                                                }`}
                                        >
                                            3
                                        </div>
                                        <span className="w-full absolute left-1/2 -translate-x-1/2 text-xs mt-2">
                                            Final-Interview
                                        </span>
                                    </div>
                                </div>

                            </div>
                        )}

                        {/* <button onClick={() => setIsStatusModalOpen(false)} className="bg-gray-500 text-white p-2 rounded mt-4">Close</button> */}
                    </div>
                    // </div>
                )}
            </div>

            {isOtpModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                    <div className="bg-white p-6 rounded">
                        <h2 className="text-lg font-semibold mb-4">Enter OTP</h2>
                        <div className="flex justify-center mb-4">
                            {otp.map((digit, index) => (
                                <input
                                    key={index}
                                    id={`otp-${index}`}
                                    type="text"
                                    maxLength="1"
                                    value={digit}
                                    onChange={(e) => handleOtpChange(index, e.target.value)}
                                    className="w-10 h-10 border border-gray-300 rounded-md mx-1 text-center"
                                />
                            ))}
                        </div>
                        {otpError && <p className="text-red-500 text-right mb-2 text-sm">{otpError}</p>}

                        <button
                            onClick={handleOtpSubmit}
                            className="button w-full"
                        >
                            Verify OTP
                        </button>
                    </div>
                </div>
            )}
            <Toaster position='bottom-center' />

        </div>
    );
};

export default TrackApplication;